import script from "./UserPotential.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPotential.vue?vue&type=script&setup=true&lang=js"

import "./UserPotential.vue?vue&type=style&index=0&id=2ddf8d66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ddf8d66"]])

export default __exports__